module.exports = __webpack_public_path__ + "img/male-solid1.550964b3.svg";